import { render } from "./QSelectMuliple.vue?vue&type=template&id=596b9cfb&scoped=true"
import script from "./QSelectMuliple.vue?vue&type=script&lang=js"
export * from "./QSelectMuliple.vue?vue&type=script&lang=js"

import "./QSelectMuliple.vue?vue&type=style&index=0&id=596b9cfb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596b9cfb"]])

export default __exports__